import MicroModal from "micromodal";
import { lock, unlock } from "tua-body-scroll-lock";
import AuthForms from "./AuthForms";
import axios from "axios";
import "regenerator-runtime/runtime.js";

/**
 * Modal logic
 */
export default class ModalController {
    constructor() {
        /**
         * DOM Selectors
         * @type {{navigationPrev: string, navigationNext: string}}
         */
        this.DOM = {
            questionModalTrigger: ".js-question-modal-trigger",
            questionModalId: "question-modal",
            authModalTrigger: ".js-auth-modal-trigger",
            authModalId: "auth-modal",
            cookieModalTrigger: ".js-cookie-modal-trigger",
            cookieModalId: "cookie-modal",
            questionTitle: ".js-question-modal-title",
            questionQuestion: ".js-question-modal-question",
            questionDate: ".js-question-modal-date",
            questionDoctor: ".js-question-modal-doctor",
            questionAnswer: ".js-question-modal-answer",
            questionAnswerDate: ".js-question-modal-answer-date",
            questionFacebook: ".js-facebookShare",
            questionTwitter: ".js-twitterShare",
            questionEmail: ".js-emailUri",
            questionPrint: ".js-printAction",
            loader: ".js-loader",
            states: {
                active: "is-active",
            },
        };
    }

    /**
     * Init modal
     * uses micromodal.js - https://github.com/Ghosh/micromodal
     */
    init() {
        MicroModal.init({
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
        });
        this.questionModal();
        this.authModal();
        this.cookieModal();
    }

    /**
     * Trigger question modal
     */
    questionModal() {
        const questionModalTrigger = document.querySelectorAll(
            this.DOM.questionModalTrigger,
        );
        const questionModal = document.querySelector(
            `#${this.DOM.questionModalId}`,
        );
        const loader = document.querySelector(this.DOM.loader);
        if (
            questionModalTrigger.length < 1 ||
            questionModal === null ||
            loader === null
        ) {
            return;
        }
        const questionTitle = questionModal.querySelector(
            this.DOM.questionTitle,
        );
        const questionDate = questionModal.querySelector(this.DOM.questionDate);
        const questionQuestion = questionModal.querySelector(
            this.DOM.questionQuestion,
        );
        const questionDoctor = questionModal.querySelector(
            this.DOM.questionDoctor,
        );
        const questionAnswer = questionModal.querySelector(
            this.DOM.questionAnswer,
        );
        const questionAnswerDate = questionModal.querySelector(
            this.DOM.questionAnswerDate,
        );
        const questionFacebook = questionModal.querySelector(
            this.DOM.questionFacebook,
        );
        const questionTwitter = questionModal.querySelector(
            this.DOM.questionTwitter,
        );
        const questionEmail = questionModal.querySelector(
            this.DOM.questionEmail,
        );
        const questionPrint = questionModal.querySelector(
            this.DOM.questionPrint,
        );
        for (let i = 0; i < questionModalTrigger.length; i++) {
            questionModalTrigger[i].addEventListener("click", (event) => {
                event.preventDefault();
                loader.classList.add(this.DOM.states.active);
                lock(questionModal.firstChild);
                (async () => {
                    try {
                        const res = await axios.get(
                            event.currentTarget.href + "?ajax=1",
                        );
                        const response = res.data;
                        questionTitle.innerHTML = response.title;
                        questionDate.innerHTML = response.date;
                        questionQuestion.innerHTML = response.question;
                        questionDoctor.innerHTML = response.doctor;
                        questionDoctor.setAttribute(
                            "href",
                            response.doctor_url,
                        );
                        questionAnswer.innerHTML = response.answer;
                        questionAnswerDate.innerHTML = response.answerDate;
                        questionFacebook.setAttribute(
                            "href",
                            response.facebook_share,
                        );
                        questionTwitter.setAttribute(
                            "href",
                            response.twitter_share,
                        );
                        questionEmail.setAttribute("href", response.email_uri);
                        questionPrint.setAttribute(
                            "onclick",
                            'printExternal("' +
                                response.permalink +
                                '"); return false;',
                        );
                        console.log(response);
                        loader.classList.remove(this.DOM.states.active);
                        MicroModal.show("question-modal", {
                            awaitOpenAnimation: true,
                            awaitCloseAnimation: true,
                            onShow: (modal) => {
                                console.log(`${modal.id} is shown`);
                            },
                            onClose: (modal) => {
                                console.log(`${modal.id} is hidden`);
                                unlock(questionModal.firstChild);
                            },
                        });
                    } catch (e) {
                        console.error(e);
                        loader.classList.remove(this.DOM.states.active);
                        unlock(questionModal.firstChild);
                    }
                })();
            });
        }
    }

    /**
     * Trigger auth modal
     */
    authModal() {
        const authModalTrigger = document.querySelectorAll(
            this.DOM.authModalTrigger,
        );
        const authModal = document.querySelector(`#${this.DOM.authModalId}`);
        if (authModalTrigger.length < 1 || authModal === null) {
            return;
        }
        const authForms = new AuthForms();
        authForms.init();
        for (let i = 0; i < authModalTrigger.length; i++) {
            authModalTrigger[i].addEventListener("click", (event) => {
                event.preventDefault();
                MicroModal.show("auth-modal", {
                    awaitOpenAnimation: true,
                    awaitCloseAnimation: true,
                    onShow: (modal) => {
                        console.log(`${modal.id} is shown`);
                        lock(authModal.firstChild);
                    },
                    onClose: (modal) => {
                        console.log(`${modal.id} is hidden`);
                        unlock(authModal.firstChild);
                        authForms.showLoginForm();
                    },
                });
            });
        }
    }

    /**
     * Trigger cookie modal
     */
    cookieModal() {
        const cookieModalTrigger = document.querySelectorAll(
            this.DOM.cookieModalTrigger,
        );
        const cookieModal = document.querySelector(
            `#${this.DOM.cookieModalId}`,
        );
        if (cookieModalTrigger.length < 1 || cookieModal === null) {
            return;
        }
        for (let i = 0; i < cookieModalTrigger.length; i++) {
            cookieModalTrigger[i].addEventListener("click", (event) => {
                event.preventDefault();
                MicroModal.show("cookie-modal", {
                    awaitOpenAnimation: true,
                    awaitCloseAnimation: true,
                    onShow: (modal) => {
                        console.log(`${modal.id} is shown`);
                        lock(cookieModal.firstChild);
                    },
                    onClose: (modal) => {
                        console.log(`${modal.id} is hidden`);
                        unlock(cookieModal.firstChild);
                    },
                });
            });
        }
    }
}
